"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderProductTypeOptions = exports.OrderProductType = exports.HospitalityTypeOtions = exports.FilterField = exports.FilterActionType = exports.DefaultFilterCriteria = void 0;
require("core-js/modules/es6.array.map.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _product = require("@nucleo/product");
var _jsxFileName = "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/constants.js",
  _this = void 0;
function cov_1nwmwn0bps() {
  var path = "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/constants.js";
  var hash = "6eed965e71132f92735d2380f0462a62017892c9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 32
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 37
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "2": {
        start: {
          line: 22,
          column: 15
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "3": {
        start: {
          line: 28,
          column: 32
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "4": {
        start: {
          line: 37,
          column: 37
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "5": {
        start: {
          line: 46,
          column: 39
        },
        end: {
          line: 56,
          column: 3
        }
      },
      "6": {
        start: {
          line: 53,
          column: 24
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "7": {
        start: {
          line: 69,
          column: 27
        },
        end: {
          line: 84,
          column: 1
        }
      },
      "8": {
        start: {
          line: 86,
          column: 37
        },
        end: {
          line: 99,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 15
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 7
          }
        },
        loc: {
          start: {
            line: 53,
            column: 24
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 53
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6eed965e71132f92735d2380f0462a62017892c9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1nwmwn0bps = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1nwmwn0bps();
var FilterActionType = exports.FilterActionType = (cov_1nwmwn0bps().s[0]++, {
  FILTER_INITIALIZATION: 'FILTER_INITIALIZATION',
  FILTER_APPLY: 'FILTER_APPLY',
  FILTER_RESET: 'FILTER_RESET',
  FILTER_LOAD_DATA_SUCCESS: 'FILTER_LOAD_DATA_SUCCESS',
  FILTER_BAR_LOAD_DATA_ERROR: 'FILTER_LOAD_DATA_ERROR',
  FILTER_LOAD_CITY_DATA_SUCCESS: 'FILTER_LOAD_CITY_DATA_SUCCESS',
  FILTER_BAR_BEFORE_LOAD_DATA: 'FILTER_BAR_BEFORE_LOAD_DATA',
  FILTER_BAR_LOAD_HOSPITALITY_SESSION_DATA_SUCCESS: 'FILTER_BAR_LOAD_HOSPITALITY_SESSION_DATA_SUCCESS',
  FILTER_BAR_LOAD_HOSPITALITY_TYPE_SUCCESS: 'FILTER_BAR_LOAD_HOSPITALITY_TYPE_SUCCESS',
  FILTER_BAR_LOAD_ODER_PRODUCT_TYPE_SUCCESS: 'FILTER_BAR_LOAD_ODER_PRODUCT_TYPE_SUCCESS',
  FILTER_BAR_LOAD_PRODUCT_TYPES_SUCCESS: 'FILTER_BAR_LOAD_PRODUCT_TYPES_SUCCESS'
});
var HospitalityTypeOtions = exports.HospitalityTypeOtions = (cov_1nwmwn0bps().s[1]++, [_product.HospitalityTypeEnum.PRIVATE, _product.HospitalityTypeEnum.SHARED].map(function (hospType) {
  cov_1nwmwn0bps().f[0]++;
  cov_1nwmwn0bps().s[2]++;
  return {
    value: hospType,
    label: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "gravity.FilterBar.hospitalityType.".concat(hospType),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 12
      }
    })
  };
}));
var OrderProductType = exports.OrderProductType = (cov_1nwmwn0bps().s[3]++, {
  PRODUCT_NAME_AZ: 'PRODUCT_NAME_AZ',
  PRODUCT_NAME_ZA: 'PRODUCT_NAME_ZA',
  LOWER_PRICE: 'LOWER_PRICE',
  HIGHER_PRICE: 'HIGHER_PRICE',
  LOWER_PRICE_PER_ATTENDEE: 'LOWER_PRICE_PER_ATTENDEE',
  HIGHER_PRICE_PER_ATTENDEE: 'HIGHER_PRICE_PER_ATTENDEE'
});
var MapOrderProductTypeWithLabel = (cov_1nwmwn0bps().s[4]++, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, OrderProductType.PRODUCT_NAME_AZ, 'productNameAZ'), OrderProductType.PRODUCT_NAME_ZA, 'productNameZA'), OrderProductType.LOWER_PRICE, 'lowerPrice'), OrderProductType.HIGHER_PRICE, 'higherPrice'), OrderProductType.LOWER_PRICE_PER_ATTENDEE, 'lowerPricePerPax'), OrderProductType.HIGHER_PRICE_PER_ATTENDEE, 'higherPricePerPax'));
var OrderProductTypeOptions = exports.OrderProductTypeOptions = (cov_1nwmwn0bps().s[5]++, [OrderProductType.PRODUCT_NAME_AZ, OrderProductType.PRODUCT_NAME_ZA, OrderProductType.LOWER_PRICE, OrderProductType.HIGHER_PRICE, OrderProductType.LOWER_PRICE_PER_ATTENDEE, OrderProductType.HIGHER_PRICE_PER_ATTENDEE].map(function (orderProdType) {
  cov_1nwmwn0bps().f[1]++;
  cov_1nwmwn0bps().s[6]++;
  return {
    value: orderProdType,
    label: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "gravity.FilterBar.orderBy.".concat(MapOrderProductTypeWithLabel[orderProdType]),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 10
      }
    })
  };
}));

/**
 * Fitler field configuration key
 * 'site',
 * 'matchName',
 * 'team',
 * 'hospitalityType',
 * 'productName',
 * 'productLineName' = name of product inside compose product,
 * 'productTypes'= custom product type config in product level,
 * 'orderProductBy',
 */
var FilterField = exports.FilterField = (cov_1nwmwn0bps().s[7]++, {
  CITY: 'city',
  SITE: 'site',
  MATCH_NAME: 'matchName',
  TEAM: 'team',
  HOSPITALITY_TYPE: 'hospitalityType',
  HOSPITALITY_SESSION: 'hospitalitySessions',
  PRODUCT_NAME: 'productName',
  PRODUCT_LINE_NAME: 'productLineName',
  PRODUCT_TYPES: 'productTypes',
  ORDER_PRODUCT_BY: 'orderProductBy',
  SPACE: 'space',
  TOPIC: 'topic',
  DATE: 'date',
  PRICE: 'price'
});
var DefaultFilterCriteria = exports.DefaultFilterCriteria = (cov_1nwmwn0bps().s[8]++, {
  minPrice: null,
  maxPrice: null,
  fromDate: null,
  toDate: null,
  date: null,
  siteIds: null,
  teamIds: null,
  matchNames: null,
  productName: null,
  productLineName: null,
  hospProductTypes: null,
  customProducTypeIds: null
});